import styled from 'styled-components';
import { IonIcon, IonModal } from '@ionic/react';

type BreakpointModalStyledProps = {
  fullWidth?: boolean | null;
  modalHeight?: string;
};

export const BreakpointModalStyled = styled(IonModal)<BreakpointModalStyledProps>`
  &::part(content) {
    border-top-left-radius: ${(props) => (props?.fullWidth ? '0px' : '20px')};
    border-top-right-radius: ${(props) => (props?.fullWidth ? '0px' : '20px')};
    max-width: 460px;
    width: ${(props) => props.fullWidth && '100%'};
    height: ${(props) => `calc(${props.modalHeight} + var(--ion-safe-area-bottom))` ?? '100%'};
    position: absolute;
    bottom: 0;
    z-index: 20023;
  }

  &::part(backdrop) {
    z-index: 20022;
  }
`;

export const ModalHeading = styled.div`
  text-align: center;
  min-width: 200px;
  padding: 19px 80px;
  background-color: #f2f4f7;
  color: #1d201f;

  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  h4 {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;

    color: #1d201f;
  }

  &.light {
    background-color: #ffffff;
    padding: 21px 70px;

    & h4 {
      font-size: 18px;
    }
  }
`;

export const CloseButton = styled(IonIcon)`
  cursor: pointer;
  top: 16px;
  right: 10px;
  position: absolute;
  width: 27px;
  height: 27px;
  color: #1d201f;
  z-index: 10000;

  &.bigger {
    width: 35px;
    height: 35px;
    color: #1d201f;
    top: 15px;
  }
`;
